import React, { useEffect, useState } from 'react';
import { Modal } from '../../components/Modal';
import { ModalFooter } from '../../components/ModalFooter';
import { MfaTokenInput } from '../../components/MfaTokenInput';
import { AlertBlock } from '../../components/AlertBlock';
import { useDeleteProject } from '../../hooks/useProject';
import { api } from '../../services/api';
import { getAccountService } from '../../services/angular-bridge';

interface Props {
  projectId: string;
  projectName: string;
  onClose: () => void;
  onDeleted: () => void;
}

export function DeleteProjectModal({ projectId, projectName, onClose, onDeleted }: Props) {
  const [token, setToken] = useState('');
  const deleteProject = useDeleteProject(projectId);
  const phone = getAccountService().Get()?.phone as string | undefined;

  useEffect(() => {
    api.post('/account/mfa/start').catch(() => {});
  }, []);

  const handleSubmit = () => {
    deleteProject.mutate({ token, projectName }, { onSuccess: onDeleted });
  };

  return (
    <Modal title="Delete Project" onClose={onClose} testId="admin-details-delete-modal" footer={
      <ModalFooter
        onClose={onClose}
        onNext={handleSubmit}
        nextLabel="Delete Project"
        nextDisabled={token.length < 7}
        saving={deleteProject.isPending}
        savingLabel="Deleting…"
        nextClassName="btn btn-danger"
      />
    }>
      <div className="alert alert-danger">
        <b>Warning!</b> This operation is not recoverable. This project will be gone forever.
        It won't return your calls, and will un-friend you on Facebook.
      </div>
      <AlertBlock type="info">
        Please enter the token provided by your{' '}
        <a target="_blank" rel="noreferrer" href="https://www.authy.com/app/mobile/">
          <i className="fas fa-mobile-phone" aria-hidden="true" /> Authy App
        </a>
        {phone ? <> or via text message to {phone}</> : null}.<br /><br />
        To change the phone number on file, visit your{' '}
        <a href="#!/settings">account settings</a>.
      </AlertBlock>
      <div className="form-group">
        <h4>Project: <small><i className="fas fa-gavel" aria-hidden="true" /> {projectName}</small></h4>
      </div>
      <MfaTokenInput testId="admin-details-delete-token-input" value={token} onChange={setToken} disabled={deleteProject.isPending} />
      {deleteProject.isError && (
        <p className="text-danger">Failed to delete project. Check your token and try again.</p>
      )}
    </Modal>
  );
}
